import API from 'src/common/api';
const methods = {
    VENDORMASTER(params) {
        return new Promise((resolve, reject) => {
            API.baseCommon.VENDORMASTER({
                vendorLike: params.query,
            })
                .done(res => {
                    if (!res.data || !res.data.records || res.data.records.length <= 0) return [];
                    const array = res.data.records.map(item => ({
                        comment: item.vendorName,
                        code: item.vendorCode,
                        source: item
                    }));
                    resolve(array)
                })
                .fail(err => {
                    reject([])
                })
        })
    },
    FIND_LIST_BY_FUZZY_NAME(params) {
        return new Promise((resolve, reject) => {
            API.baseCommon.FIND_LIST_BY_FUZZY_NAME({
                fuzzyName: params.query,
            })
                .done(res => {
                    if (!res.data || !res.data || res.data.length <= 0) return [];
                    const array = res.data.map(item => ({
                        comment: item.adminUserName,
                        code: item.loginId,
                        source: item
                    }));
                    resolve(array)
                })
                .fail(err => {
                    reject([])
                })
        })
    },
    POST_VENDOR_FIND_BANK_INFO(params) {
        return new Promise((resolve, reject) => {
            API.autoAPi.POST_VENDOR_FIND_BANK_INFO({
                vendorCode: params.query,
            })
                .done(res => {
                    if (res.data.length <= 0) return [];
                    const array = res.data.map(item => ({
                        comment: item.bankAccountNo,
                        code: item.bankAccountNo,
                        source: item
                    }));
                    resolve(array)
                })
                .fail(err => {
                    reject([])
                })
        })
    },
    POST_APPOINT_MEMBER_LIST(params) {
        return new Promise((resolve, reject) => {
            API.baseCommon.POST_APPOINT_MEMBER_LIST({
                fuzzyName: params.query,
            })
                .done(res => {
                    if (res.data.length <= 0) return [];
                    const array = res.data.map(item => ({
                        comment: item.adminUserName,
                        code: item.loginId,
                        source: item
                    }));
                    resolve(array)
                })
                .fail(err => {
                    reject([])
                })
        })
    },
    POST_STORAGE_FIND_LIST(params) {
        params.storageLike = params.query
        return new Promise((resolve, reject) => {
          API.autoAPi.POST_STORAGE_FIND_LIST(params)
            .done(res => {
              if (res.data.length <= 0) return [];
              const array = res.data.map((item,index) => ({
                comment: item.storageDesc,
                code: item.storageCode,
                source: item
              }));
              resolve(array)
            })
            .fail(err => {
              reject([])
            })
        })
      },
      POST_SUPPLIER_LIST_SUPPLIER_TYC_COMPANY_NAME(params) {
        return new Promise((resolve, reject) => {
            API.autoAPi.POST_SUPPLIER_LIST_SUPPLIER_TYC_COMPANY_NAME({
              ...params
            })
                .done(res => {
                    if (res.data.length <= 0) return [];
                    const array = res.data.map(item => ({
                        comment: item +'  ',
                        code: item,
                        source: item
                    }));
                    resolve(array)
                })
                .fail(err => {
                    reject([])
                })
        })
    },
//     VENDOR_ADMITTANCE_TYCSEARCH(params) {
//         return new Promise((resolve, reject) => {
//             API
//                 .DeclarationInfo
//                 .VENDOR_ADMITTANCE_TYCSEARCH({
//                     companyName: params.query
//                 })
//                 .done(res => {
//                     resolve(res.list.map(item => ({
//                         comment: item.companyName,
//                         code: item.companyTycId
//                     })))
//                 })
//                 .fail(err => {
//                     console.log(err)
//                     reject([])
//                 })
//         })
//     },
//     Material_SearchMaterial_CodeOrDesc(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.Material_SearchMaterial_CodeOrDesc({ searchString: params.query })
//                 .done(res => {
//                     const array = res.list.map(item => ({
//                         comment: item.materialCode,
//                         code: item.materialCode
//                     }))
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_MATERIAL_FIND_PRODUCTSAMPLE(params) {
//       return new Promise((resolve, reject) => {
//         API.autoAPi.POST_MATERIAL_FIND({
//           materialCode: params.query,
//         })
//           .done(res => {
//             if (!res?.data?.length) return [];
//             const array = res.data.map(item => {
//               return {
//                 comment: item.materialDesc,
//                 code: item.materialCode,
//                 source: item
//               }
//             })
//             resolve(array)
//           })
//           .fail(err => {
//             reject([])
//           })
//       })
//     },
//     Material_SearchMaterial_CodeOrDescCN(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.Material_SearchMaterial_CodeOrDesc({ searchString: params.query })
//                 .done(res => {
//                     const array = res.list.map(item => ({
//                         comment: item.materialDescCn,
//                         code: item.materialCode
//                     }))
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     VENDORMASTER(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.VENDORMASTER({ '$filter': params.query })
//                 .done(res => {
//                     const array = res.list.map(item => ({
//                         comment: item.vendor.vendorName,
//                         code: item.vendor.vendorCode
//                     }))
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })

//     },
//   getSystemEnum(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.getSystemEnum({
//                 ...params
//             }
//             )
//                 .done(res => {
//                     const array =  res.list[0].enumValue.map(item => ({
//                         comment: item.valueDesc,
//                         code: item.valueCode
//                     }))
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })

//     },
//     DIMENSION_DETAIL_URL(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.DIMENSION_DETAIL_URL(params)
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list[0].featureDetails.map(setChildren);
//                     resolve(array)
//                     function setChildren(item) {
//                         return {
//                             comment: item.featureValueDesc,
//                             code: item.featureValueCode,
//                             type: item.deleteFlag
//                         }
//                     }
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     VENDOR_ACCOUNT_MATERIAL_GRID(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.VENDOR_ACCOUNT_MATERIAL_GRID({
//                 materialCode: params.materialCode,
//                 size: 10,
//                 grid: params.query
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.gridName,
//                         code: item.gridCode
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     VENDOR_ACCOUNT_MATERIAL_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.VENDOR_ACCOUNT_MATERIAL_LIST({
//                 materialCode: params.query,
//                 size: 10
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item,
//                         code: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     VENDOR_ACCOUNT_RELATEDMATERIAL_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.VENDOR_ACCOUNT_RELATEDMATERIAL_LIST({
//                 materialCode: params.query,
//                 brand: params.brand,
//                 size: 10,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.materialDesc,
//                         code: item.materialCode
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     VENDORMASTER(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.VENDORMASTER({
//                 '$filter': params.query
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.vendor.vendorName,
//                         code: item.vendor.vendorCode
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     QCSCHELING_SELECTCONFIRMQCUSERNAME(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.QCSCHELING_SELECTCONFIRMQCUSERNAME({
//                 filterString: params.query
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.qcCode,
//                         code: item.qcName
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     MASTERDATA_GRID_DATA(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.MASTERDATA_GRID_DATA({
//                 grid: params.query,
//                 ...params
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.gridName,
//                         code: item.gridCode
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_SUPPLIER_FIND_PAGE(params) {
//       params.vendorLike = params.query
//       return new Promise((resolve, reject) => {
//         API.autoAPi.POST_SUPPLIER_FIND_PAGE(params)
//           .done(res => {
//             if (res.data.length <= 0) return [];
//             const array = res.data.records.map((item,index) => ({
//               comment: item.vendorName,
//               code: item.vendorCode,
//               source: item
//             }));
//             resolve(array)
//           })
//           .fail(err => {
//             reject([])
//           })
//       })
//     },
//     ACCESSORY_MATERIAL_COLOR_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.excipient.ACCESSORY_MATERIAL_COLOR_LIST({
//                 colorCode: params.query,
//                 ...params
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.colorName,
//                         code: item.colorCode
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_PR_PREVIEW_COLOR_CODE(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_PR_PREVIEW_COLOR_CODE({
//                 colorCode: params.query,
//                 ...params
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.colorName,
//                         code: item.colorCode
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_PROJECT_COST_CODE_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_PROJECT_COST_CODE_LIST({
//                 temporaryMaterialCode: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.temporaryMaterialCode,
//                         code: item.temporaryMaterialCode,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_PROJECT_COST_MATERIAL_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_PROJECT_COST_MATERIAL_LIST({
//                 materialCode: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.materialDesc,
//                         code: item.materialCode,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_APPOINT_MEMBER_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_APPOINT_MEMBER_LIST({
//                 memberName: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.memberName,
//                         code: item.memberId,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_APPOINT_PM_CODE_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_APPOINT_PM_CODE_LIST({
//                 orderNo: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item,
//                         code: item,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_APPOINT_PM_MATERIAL_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_APPOINT_PM_MATERIAL_LIST({
//                 materialCode: params.query,
//                 orderNo: params.orderNo
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item,
//                         code: item,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_SYSTEM_ENUM_TYPEVALUE(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_SYSTEM_ENUM_TYPEVALUE({
//                 valueDesc: params.query,
//                 typeCode: params.typeCode
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.valueDesc,
//                         code: item.valueDesc,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_APPOINT_PM_MATERIALCODE_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_APPOINT_PM_MATERIALCODE_LIST({
//                 materialCode: params.query
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: '',
//                         code: item,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_APPOINT_PM_ORDERCODE_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_APPOINT_PM_ORDERCODE_LIST({
//                 materialCode: params.materialCode,
//                 orderNo: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item,
//                         code: item,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_APPOINT_PM_ORDERANDNUM_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_APPOINT_PM_ORDERANDNUM_LIST({
//                 materialCode: params.materialCode,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: `${item.orderNum}件`,
//                         code: item.orderNo,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_APPOINT_PM_ORDERANDNUM_LIST(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_APPOINT_PM_ORDERANDNUM_LIST({
//                 materialCode: params.materialCode,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: `${item.orderNum}件`,
//                         code: item.orderNo,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     VENDORMASTER(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.VENDORMASTER({
//                 $filter: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.vendor.vendorName,
//                         code: item.vendor.vendorCode,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     QUERY_BY_QC_NAME_URL(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.QUERY_BY_QC_NAME_URL({
//                 filter: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.adminUserName,
//                         code: item.adminUserName,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     USER_ACTION_QUERY_USER_URL(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.USER_ACTION_QUERY_USER_URL({
//                 query: params.query,
//             })
//                 .done(res => {
//                     if (res.data.length <= 0) return [];
//                     const array = res.data.map(item => ({
//                         comment: item.adminUserName,
//                         code: item.adminUserName,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_PR_PREVIEW_CODE(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_PR_PREVIEW_CODE({
//                 materialCode: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item,
//                         code: item,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },

//     POST_VENDOR_FIND_BANK_INFO(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_VENDOR_FIND_BANK_INFO({
//               vendorCode: params.query,
//             })
//                 .done(res => {
//                     if (res.data.length <= 0) return [];
//                     const array = res.data.map(item => ({
//                         comment: item.bankAccountNo,
//                         code: item.bankAccountNo,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//   POST_FACTORY_QUOTE_CODE(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_FACTORY_QUOTE_CODE({
//                 materialCode: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item,
//                         code: item,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     POST_SYSTEM_ENUM_CODEVALUE(params) {
//         return new Promise((resolve, reject) => {
//             API.autoAPi.POST_SYSTEM_ENUM_CODEVALUE({
//                 typeCode: params.code,
//                 valueDesc: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.valueDesc,
//                         code: item.valueCode,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//     GET_MATERIAL_SELECTSUPPLYMASTERDATAMATERIALCODE(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.GET_MATERIAL_SELECTSUPPLYMASTERDATAMATERIALCODE({
//                 query: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item,
//                         code: item,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     },
//   GET_FABRIC_MASTERDATA_SEARCHMATERIALCODEORDESC(params) {
//         return new Promise((resolve, reject) => {
//             API.baseCommon.GET_FABRIC_MASTERDATA_SEARCHMATERIALCODEORDESC({
//                 query: params.query,
//             })
//                 .done(res => {
//                     if (res.list.length <= 0) return [];
//                     const array = res.list.map(item => ({
//                         comment: item.materialDescCn,
//                         code: item.materialCode,
//                         source: item
//                     }));
//                     resolve(array)
//                 })
//                 .fail(err => {
//                     reject([])
//                 })
//         })
//     }
};

export function syncGetSearch(apiName, params) {
    return methods[apiName](params)
}
